/**
 * Opengater subscription-mirrors hooks (users service, `admin: subscription-
 * mirrors`). A CRUD list: GET all, POST create, PATCH update, DELETE remove.
 * Every mutation invalidates the list so the table reflects the server.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/subscription-mirrors';
const KEY = ['og', 'mirrors'];
export function useOgMirrors() {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiOg('users', PATH),
    });
}
export function useCreateOgMirror() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('users', PATH, { method: 'POST', body }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
export function useUpdateOgMirror() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, patch }) => apiOg('users', `${PATH}/${id}`, {
            method: 'PATCH',
            body: patch,
        }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
export function useDeleteOgMirror() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiOg('users', `${PATH}/${id}`, { method: 'DELETE' }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
